import CustomModal from "../../../common-utilities/core/modal";
import "./index.scss";
import { useState } from "react";
import { HTMLTable } from "../table/html-table";
export const InfomationModal = ({
  title,
  onClose,
  useSiTable,
  data,
  allLabelsAndKeys,
}) => {
  const [page, setPage] = useState(1);
  return (
    <div className="information-modal">
      <CustomModal title={title} onClose={onClose}>
        {useSiTable ? (
          <HTMLTable
            header={allLabelsAndKeys}
            filters={page}
            data={data.slice((page - 1) * 10, (page - 1) * 10 + 10)}
            pageCount={Math.ceil(data.length / 10)}
            onChange={(_, page) => {
              setPage(page);
            }}
          />
        ) : (
          <>
            {allLabelsAndKeys.map((item, index) => {
              return (
                <div className="item-label-value" key={index}>
                  <div>{item.label}</div>
                  <div>
                    -
                    {item.convertedValue
                      ? item?.convertedValue(data)
                      : data[item.value]}
                  </div>
                </div>
              );
            })}
          </>
        )}
      </CustomModal>
    </div>
  );
};
